import { gqlClient, gqlWithLoading } from './client'

// Get the users saved payment methods
const getPayments = async (productId) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      query getPayments{
        payments {
            savedPaymentInfo {
                preferredPaymentInfoId
                paymentInfos {
                    description id methodId
                }
            }
        }
      }`,
      variables: {
        input: {
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

// Get the users saved payment methods
const getOrders = async () => {
  try {
    let response = await gqlClient.post('', {
      query: `
      query Search($where: OrderSearchFilterInput) {
        orders {
          search(where: $where) {
            state
            id
            items {
              id
              product {
                productCategory
                title
                description
              }
              destination {
                ... on MsisdnEndpointIdentifier {
                  msisdn
                }
              }
            }
            summary {
              total {
                formatted
              }
            }
            createdAt
          }
        }
      }`,
      variables: {
        where: {
          states: {
            in: ['IN_PROGRESS', 'IN_PROGRESS_DESTINATION_PENDING']
          }
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}
// Cancel order
const cancelOrder = async (id) => {
  try {
    let response = await gqlClient.post('', {
      query: `mutation CancelOrder($input: CancelOrderInput!) {
        orders {
          cancelOrder(input: $input) {
            order {
              id
            }
          }
        }
      }
      `,
      variables: {
        input: {
          orderId: id
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}
// Creates and validates an order TODO CLEANUP!!!
const createAndValidateOrder = async (msisdn, productId) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      mutation Mutation($input: CreateAndValidateOrderInput!) {
        orders {
          createAndValidateOrder(input: $input) {
            orderId
            order {
              id
              state
              items {
                productId
                product {
                  validity {
                    quantity
                    unit
                    formatted
                  }
                  frequencies {
                    frequency {
                      formatted
                      quantity
                      unit
                    }
                    preselected
                  }
                  subscriptionAvailability,
                  countryId,
                  productCategory,
                  productSubCategory,
                  serviceCategory,
                  title,
                  description,
                  value {
                    amount,
                    currency,
                    formatted
                  },
                  price {
                    formatted,
                    amount
                  }
                }
                destination {
                  ... on MsisdnEndpointIdentifier {
                    msisdn
                  }
                }
              }
              summary {
                credits {
                  amount
                  currency
                  formatted
                }
                total {
                  formatted,
                  amount
                }
                fees {
                  formatted
                }
                deductions {
                  formatted,
                  amount
                }
                vats {
                  vatAmount {
                    formatted,
                    amount
                  }
                  vatPercent
                }
                netAmount {
                  amount,
                  currency,
                  formatted
                }
              }
              createdAt
              paymentOptions {
                methods {
                  clientConfiguration
                  description
                  id
                  methodType
                  name
                  sdk
                }
                savedMethods {
                  description
                  id
                  lastUsedAt
                  methodType
                  isAvailable
                  brand {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
      `,
      variables: {
        input: {
          productId: productId,
          destination: {
            type: 'MSISDN',
            msisdn: msisdn
          }
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

// create and validate nauta order only

const createAndValidateNautaOrder = async (email, productId) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      mutation Mutation($input: CreateAndValidateOrderInput!) {
        orders {
          createAndValidateOrder(input: $input) {
            orderId
            order {
              id
              state
              items {
                productId
                product {
                  productCategory,
                  serviceCategory,
                  title,
                  description,
                  value {
                    amount,
                    currency,
                    formatted
                  },
                  price {
                    formatted,
                    amount
                  }
                }
                destination {
                  ... on EmailEndpointIdentifier {
                    email
                  }
                }
              }
              summary {
                credits {
                  amount
                  currency
                  formatted
                }
                total {
                  formatted,
                  amount
                }
                fees {
                  formatted
                }
                deductions {
                  formatted,
                  amount
                }
                vats {
                  vatAmount {
                    formatted,
                    amount
                  }
                  vatPercent
                }
                netAmount {
                  amount,
                  currency,
                  formatted
                }
              }
              createdAt
              paymentOptions {
                methods {
                  clientConfiguration
                  description
                  id
                  methodType
                  name
                  sdk
                }
                savedMethods {
                  description
                  id
                  lastUsedAt
                  methodType
                  isAvailable
                  brand {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
      `,
      variables: {
        input: {
          productId: productId,
          destination: {
            type: 'EMAIL',
            email: email
          }
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}
// Create and Validate Prebooking
const createAndValidatePrebooking = async (input) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      mutation CreateAndValidatePreBooking($input: CreateAndValidatePreBookingInput!) {
        subscriptions {
          createAndValidatePreBooking(input: $input) {
            id
            preBooking {
              product {
                value {
                  amount
                  currency
                  formatted
                }
                description
                price {
                  amount
                  currency
                  formatted
                }
                productCategory
                productSubCategory
                serviceCategory
                countryId
                title
                id
              }
              summary {
                deductions {
                  amount
                  currency
                  formatted
                }
                fees {
                  amount
                  currency
                  formatted
                }
                netAmount {
                  amount
                  currency
                  formatted
                }
                total {
                  amount
                  currency
                  formatted
                }
                vat {
                  subscriptionAmount {
                    amount
                    currency
                    formatted
                  }
                  vatAmount {
                    amount
                    currency
                    formatted
                  }
                  vatPercent
                }
              }
              state
              id
              nextExecutionTime
              paymentOptions {
                savedMethods {
                  description
                  id
                  isAvailable
                  lastUsedAt
                  methodType
                  brand {
                    cvcLength
                    id
                    name
                    pattern
                  }
                }
                methods {
                  brands {
                    cvcLength
                    id
                    name
                    pattern
                  }
                  clientConfiguration
                  description
                  id
                  methodType
                  name
                  sdk
                }
              }
              destination
            }
          }
          }
      }
        `,
      variables: {
        input: {
          productId: input.id,
          destination: {
            type: 'MSISDN',
            msisdn: input.msisdn
          }
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}
// Submit prebooking order with NEW payment method
const submitPrebookingOrder = async (input) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      mutation PreBookingSubmitRecurring($input: PreBookingSubmitRecurringInput!) {
        subscriptions {
          submitRecurringPreBooking(input: $input) {
            id
          }
        }
      }
        `,
      variables: {
        input: {
          savedMethodId: input.savedMethodId,
          preBookingId: input.preBookingId,
          sessionDataId: input.sessionDataId,
          sessionData: input.sessionData
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}
const cancelSubscription = async (id, deleteSavedMethodId) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      mutation CancelSubscription($input: CancelSubscriptionInput!) {
        subscriptions {
          cancelSubscription(input: $input) {
            subscriptionId
            subscription {
              state
            }
          }
        }
      }
        `,
      variables: {
        input: {
          subscriptionId: id,
          deleteSavedMethodId
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}
const reActivateSubscription = async (id) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      mutation ReactivateSubscription($input: ReactivateSubscriptionInput!) {
        subscriptions {
          reactivateSubscription(input: $input) {
            id
            subscription {
              state
            }
          }
        }
      }
        `,
      variables: {
        input: {
          id: id
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchTopupSubscriptions = async () => {
  try {
    let response = await gqlWithLoading.post('/graphql', {
      query: `
      query Search($where: SubscriptionSearchFilterInput) {
        subscriptions {
          search(where: $where) {
            destination
            id
            nextExecutionTime
            created
            state
            cancelledAt
            paymentOptions {
              savedMethods {
                status
                brand {
                  id
                }
                description
                id
                methodType
              }
            }
            savedMethod {
              description
              status
              id
              methodType
              brand {
                id
              }
            }
            product {
              operator {
                name
              }
              id
              productCategory
              productSubCategory
              serviceCategory
              countryId
              value {
                amount
                currency
                formatted
              }
              price {
                amount
                currency
                formatted
              }
              title
              description
              frequencies {
                frequency {
                  quantity
                }
              }
            }
            frequency
            subscriptionType
            reactivatedAt
          }
        }
      }
        `,
      variables: {
        where: {
          subscriptionTypes: {
            in: ['SUBSCRIPTION']
          }
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}
const fetchTopupSubscriptionsByFilter = async (input) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      query Search($where: SubscriptionSearchFilterInput) {
        subscriptions {
          search(where: $where) {
            destination
            id
            state
            product {
              id
              value {
                amount
                currency
                formatted
              }
              title
              description
            }
            frequency
            subscriptionType
          }
        }
      }
        `,
      variables: {
        where: {
          and: [
            {
              subscriptionTypes: {
                in: ['SUBSCRIPTION']
              }
            },
            {
              productsIds: {
                in: input.productId
              }
            },
            {
              destinations: {
                in: [
                  {
                    type: input.destination.type,
                    msisdn: input.destination.msisdn
                  }
                ]
              }
            },
            {
              subscriptionStateId: {
                in: ['ACTIVE']
              }

            }
          ]
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}
// create subscription after order flow is done
const createAndValidateSubscription = async (input) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      mutation CreateAndValidateCyclicSubscription($input: CreateAndValidateCyclicSubscriptionInput!) {
        subscriptions {
          createAndValidateCyclicSubscription(input: $input) {
            id
            subscription {
              state
              productId
              nextExecutionTime
              frequency
              paymentOptions {
                savedMethods {
                  isAvailable
                  lastUsedAt
                  id
                }
              }
            }
          }
        }
      }
        `,
      variables: {
        input: {
          productId: input.productId,
          frequency: input.frequency,
          destination: {
            type: 'MSISDN',
            msisdn: input.msisdn
          },
          firstOrderId: input.orderId
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}
// Submit Subscription after order flow
const submitRecurringSubscription = async (input) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      mutation SubmitRecurringSubscription($input: SubscriptionSubmitRecurringInput!) {
        subscriptions {
          submitRecurringSubscription(input: $input) {
            id
            subscription {
              productId
              state
            }
          }
        }
      }
        `,
      variables: {
        input: {
          savedMethodId: input.savedMethodId,
          subscriptionId: input.subscriptionId,
          sessionDataId: input.sessionDataId,
          sessionData: input.sessionData
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

// Submit order with NEW payment method
const submitOrder = async (input) => {
  if (input.savedMethodId) {
    try {
      let response = await gqlClient.post('', {
        query: `
        mutation SubmitOrderRecurringV2($input: OrderSubmitRecurringV2Input!) {
          orders {
            submitOrderRecurringV2(input: $input) {
              orderId
              providerData
            }
          }
        }
        `,
        variables: {
          input: {
            savedMethodId: input.savedMethodId,
            orderId: input.orderId,
            sessionDataId: input.sessionDataId,
            sessionData: input.sessionData,
            providerData: input.providerData
          }
        }
      })
      return response.data
    } catch (error) {
      throw error
    }
  } else {
    try {
      let response = await gqlClient.post('', {
        query: `
        mutation submitOrderV2($input: OrderSubmitV2Input!) {
          orders {
            submitOrderV2(input: $input) {
                orderId
                providerData
            }
          }
        }`,
        variables: {
          input: {
            orderId: input.orderId,
            methodId: input.methodId,
            methodType: input.methodType,
            sessionDataId: input.sessionDataId,
            sessionData: input.sessionData,
            providerData: input.providerData,
            providerDataSecret: input.providerDataSecret,
            email: input.email,
            countryId: input.countryId,
            stateId: input.stateId,
            zip: input.zip,
            name: input.name,
            city: input.city,
            address: input.address
          }
        }
      })
      return response.data
    } catch (error) {
      throw error
    }
  }
}

// After pay is pressed, keep on checing the status, if pending, go on... until complete...
const getOrderState = async (orderId) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      query getOrderStatus($orderId: ID!) {
        orders {
          search(where: { orderIds: { in: [$orderId]}})  {
            id
            state
            payment {
              providerData,
              savedMethodId
            }
          }
        }
      }`,
      variables: {
        orderId: orderId
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

// For submitting 3D security data
const submit3DSecureData = async (data) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      mutation SubmitPaymentData($input: OrderSubmitPaymentDataInput!) {
        orders {
          submitPaymentData(input: $input) {
            orderId
          }
        }
      }`,
      variables: {
        input: {
          orderId: data.orderId,
          providerData: data.providerData
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const getOperatorByMsisdn = async (msisdns) => {
  try {
    const response = await gqlWithLoading.post('/graphql', {
      query: `
      mutation OperatorLookup($input: OperatorLookupInput!) {
        availability {
          operatorLookup(input: $input) {
            operators {
              operator {
                name
                countryId
                logoUrl
              }
              operatorId
            }
          }
        }
      }`,
      variables: {
        input: {
          msisdns
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const getOperatorByCountry = async (countryId) => {
  try {
    const response = await gqlWithLoading.post('/graphql', {
      query: `
      query Search($where: OperatorsSearchFilterInput) {
        availability {
          operators {
            search(where: $where) {
              countryId
              id
              logoUrl
              name
              priority
            }
          }
        }
      }`,
      variables: {
        where: {
          countryIds: {
            in: [countryId]
          }
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const getOperatorByEmail = async (email) => {
  try {
    const response = await gqlWithLoading.post('/graphql', {
      query: `
      mutation OperatorLookupByDestination($input: OperatorLookupByDestinationInput!) {
        availability {
          operatorLookupByDestination(input: $input) {
            operator {
              countryId
              id
              logoUrl
              name
              priority
            }
            operatorId
            destination {
              ... on EmailEndpointIdentifier {
                email
              }
            }
          }
        }
      }`,
      variables: {
        input: {
          destination: {
            email,
            type: 'EMAIL'
          }
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const getOrderHistory = async (state) => {
  try {
    const response = await gqlWithLoading.post('/graphql', {
      query: `query Destination($where: OrderSearchFilterInput, $pagination: PaginationInput) {
        orders {
          search(where: $where, pagination: $pagination orderBy: { order: DESC, by: "id" }) {
            items {
              destination {
                ... on MsisdnEndpointIdentifier {
                  msisdn
                }
              }
              product {
                id
                productCategory
              }
              id
            }
          }
        }
      }`,
      variables: {
        where: {
          states: {
            in: state
          }
        },
        pagination: {
          take: 3
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const getBundleProducts = async (operatorId) => {
  try {
    const response = await gqlWithLoading.post('/graphql', {
      query: `
      query getBundleProducts ($operatorId: [OperatorId!]){
            products{
              search(
                where: {
                and: [
                {serviceCategories: { in: MTU }},
                {productCategories: { in: MTU_PLANS_BUNDLES }},
                {operatorIds: { in: $operatorId }}
                ]
              }
              orderBy: { order: ASC, by: "price" }
              ) {
                id
                title
                description
                countryId
                operator {
                  id
                  name
                }
                productSubCategory
                price {
                  currency
                  amount
                  formatted
                }
                deliverables {
                  amount
                  unit
                  deliverableType
                  unitType
                }
                operatorId
                productCategory
                campaign {
                  price {
                    amount
                    currency
                    formatted
                  }
                  title
                  description
                }
                promotions {
                  id
                  startAt
                  endAt
                  title
                  description
                  terms
                  operatorId
                  operator {
                    id
                    countryId
                    name
                    priority
                    logoUrl
                  }
                  productIds
                  products {
                    title
                    description
                  }
                }
                validity {
                  quantity
                  unit
                  formatted
                }
              }
            }
          }`,
      variables: {
        operatorId
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const getMtuProducts = async (operatorId) => {
  try {
    const response = await gqlWithLoading.post('/graphql', {
      query: `
      query getMtuProducts ($operatorId: [OperatorId!]){
            products{
              search(
                where: {
                and: [
                {serviceCategories: { in: MTU }},
                {productCategories: { in: MTU_CREDITS }},
                {operatorIds: { in: $operatorId }}
                ]
              }
              orderBy: { order: ASC, by: "price" }
              ) {
                id
                title
                description
                countryId
                operator {
                  id
                  name
                }
                productSubCategory
                price {
                  currency
                  amount
                  formatted
                }
                value {
                  amount
                  currency
                  formatted
                }
                operatorId
                productCategory
                campaign {
                  price {
                    amount
                    currency
                    formatted
                  }
                  title
                  description
                }
                promotions {
                  id
                  startAt
                  endAt
                  title
                  description
                  terms
                  operatorId
                  operator {
                    id
                    countryId
                    name
                    priority
                    logoUrl
                  }
                  productIds
                  products {
                    title
                    description
                  }
                }
                validity {
                  quantity
                  unit
                  formatted
                }
              }
            }
          }`,
      variables: {
        operatorId
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const getNautaProducts = async (operatorId) => {
  try {
    const response = await gqlWithLoading.post('/graphql', {
      query: `
      query getBundleProducts ($operatorId: [OperatorId!]){
            products{
              search(
                where: {
                and: [
                {serviceCategories: { in: MTU }},
                {productSubCategories: { in: MTU_PLANS_BUNDLES_NAUTA }},
                {operatorIds: { in: $operatorId }}
                ]
              }
              orderBy: { order: ASC, by: "price" }
              ) {
                id
                title
                description
                countryId
                operator {
                  id
                  name
                }
                productSubCategory
                price {
                  currency
                  amount
                  formatted
                }
                deliverables {
                  amount
                  unit
                  deliverableType
                  unitType
                }
                operatorId
                productCategory
                campaign {
                  price {
                    amount
                    currency
                    formatted
                  }
                  title
                  description
                }
                promotions {
                  id
                  startAt
                  endAt
                  title
                  description
                  terms
                  operatorId
                  operator {
                    id
                    countryId
                    name
                    priority
                    logoUrl
                  }
                  productIds
                }
                validity {
                  quantity
                  unit
                  formatted
                }
              }
            }
          }`,
      variables: {
        operatorId
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const getProductInfo = async (productId) => {
  try {
    const response = await gqlWithLoading.post('/graphql', {
      query: `
      query Search($where: ProductsSearchFilterInput) {
        products {
          search(where: $where) {
            deliverables {
              amount
              deliverableType
              unit
              unitType
            }
            description
            destinationTypes
            price {
              amount
              currency
              formatted
            }
            productCategory
            productSubCategory
            campaign {
              campaignId
            }
          }
        }
      }`,
      variables: {
        where: {
          productIds: {
            in: productId
          }
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const getAvailableCountriesForMTU = async () => {
  try {
    const response = await gqlWithLoading.post('/graphql', {
      query: `query Countries($where: ProductCountriesSearchFilterInput) {
        availability {
          countries {
            search(where: $where) {
              id
              providerOverride
            }
          }
        }
      }`,
      variables: {
        where: {
          serviceCategories: {
            in: 'MTU'
          }
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}
const getAllMtuProducts = async (operatorId, locale) => {
  try {
    const response = await gqlWithLoading.post('/graphql', {
      query: `
      query GetAllMtuProductsByPriority($operatorId: String!, $where: ProductsSearchFilterInput) {
        products {
            configuration {
                productCategoryConfiguration(operatorId: $operatorId) {
                    priority
                    productCategory
                }
            }
            search(where: $where, order: [{ order: ASC, by: "priority" }{order: ASC, by: "price"}],includePlans:true) {
                id
                title
                serviceCategory
                description
                countryId
                priority
                summary
                operator {
                    id
                    name
                }
                deliverables{
                  summary
                  deliverableType,
                  unitType
                  amount
                  unit
                }
                destinationTypes
                productSubCategory
                price {
                    amount
                    currency
                    formatted
                }
                deliverables {
                    amount
                    unit
                    deliverableType
                    unitType
                }
                operatorId
                productCategory
                campaign {
                    campaignId
                    price {
                        amount
                        currency
                        formatted
                    }
                    title
                    description
                }
                promotions {
                    id
                    startAt
                    endAt
                    title
                    description
                    terms
                    operatorId
                    operator {
                        id
                        countryId
                        name
                        priority
                        logoUrl
                    }
                    productIds
                    products {
                        title
                    }
                }
                validity {
                    formatted
                    quantity
                    unit
                }
                value {
                    amount
                    currency
                    formatted
                }
                fee {
                    amount
                    currency
                    formatted
                }
                frequencies {
                    frequency {
                        formatted
                        quantity
                        unit
                    }
                    preselected
                }
            }
        }
    }
    `,
      variables: {
        operatorId,
        where: {
          operatorIds: {
            in: [operatorId]
          }
        }
      }
    },
    {
      headers: {
        Locale: locale
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const removeSubscription = async (id) => {
  try {
    let response = await gqlWithLoading.post('/graphql', {
      query: `
      mutation Mutation($input: RemoveSubscriptionInput!) {
        subscriptions {
          removeSubscription(input: $input) {
            success
          }
        }
      }
        `,
      variables: {
        input: {
          subscriptionId: id
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const updateSubscription = async (subscriptionId, methodId) => {
  try {
    let response = await gqlWithLoading.post('/graphql', {
      query: `
      mutation UpdateSubscription($input: UpdateSubscriptionInput!) {
        subscriptions {
          updateSubscription(input: $input) {
            id
            subscription {
              state
            }
          }
        }
      }
        `,
      variables: {
        input: {
          id: subscriptionId,
          savedMethodId: methodId
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchCubaBannerInfo = async (countryId) => {
  try {
    let response = await gqlClient.post('', {
      query: `
      query Promotions($where: PromotionSearchFilterInput) {
        promotions {
          search(where: $where) {
            startAt
            endAt
          }
        }
      }`,
      variables: {
        where: {
          countryIds: {
            in: [countryId]
          }
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const useCreditBalance = async (orderId) => {
  try {
    let response = await gqlWithLoading.post('/graphql', {
      query: `
      mutation UseCreditBalance($input: UseCreditBalanceInput!) {
        orders {
          useCreditBalance(input: $input) {
            id
            order {
              id
              state
              summary {
                credits {
                  amount
                  currency
                  formatted
                }
                deductions {
                  amount
                  currency
                  formatted
                }
                fees {
                  amount
                  currency
                  formatted
                }
                netAmount {
                  amount
                  currency
                  formatted
                }
                total {
                  amount
                  currency
                  formatted
                }
                vats {
                  itemsAmount {
                    amount
                    currency
                    formatted
                  }
                  vatAmount {
                    amount
                    currency
                    formatted
                  }
                  vatPercent
                }
              }
              items {
                productId
                product {
                  validity {
                    quantity
                    unit
                    formatted
                  }
                  frequencies {
                    frequency {
                      formatted
                      quantity
                      unit
                    }
                    preselected
                  }
                  subscriptionAvailability,
                  countryId,
                  productCategory,
                  productSubCategory,
                  serviceCategory,
                  title,
                  description,
                  value {
                    amount,
                    currency,
                    formatted
                  },
                  price {
                    formatted,
                    amount
                  }
                }
                destination {
                  ... on MsisdnEndpointIdentifier {
                    msisdn
                  }
                }
              }
              createdAt
              paymentOptions {
                methods {
                  clientConfiguration
                  description
                  id
                  methodType
                  name
                  sdk
                }
                savedMethods {
                  description
                  id
                  lastUsedAt
                  methodType
                  isAvailable
                  brand {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
        `,
      variables: {
        input: {
          orderId: orderId
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const removeCreditBalance = async (orderId) => {
  try {
    let response = await gqlWithLoading.post('/graphql', {
      query: `
      mutation RemoveCreditBalance($input: RemoveCreditBalanceInput!) {
        orders {
          removeCreditBalance(input: $input) {
            order {
              id
              state
              summary {
                credits {
                  amount
                  currency
                  formatted
                }
                deductions {
                  amount
                  currency
                  formatted
                }
                fees {
                  amount
                  currency
                  formatted
                }
                netAmount {
                  amount
                  currency
                  formatted
                }
                total {
                  amount
                  currency
                  formatted
                }
                vats {
                  itemsAmount {
                    amount
                    currency
                    formatted
                  }
                  vatAmount {
                    amount
                    currency
                    formatted
                  }
                  vatPercent
                }
              }
              items {
                productId
                product {
                  validity {
                    quantity
                    unit
                    formatted
                  }
                  frequencies {
                    frequency {
                      formatted
                      quantity
                      unit
                    }
                    preselected
                  }
                  subscriptionAvailability,
                  countryId,
                  productCategory,
                  productSubCategory,
                  serviceCategory,
                  title,
                  description,
                  value {
                    amount,
                    currency,
                    formatted
                  },
                  price {
                    formatted,
                    amount
                  }
                }
                destination {
                  ... on MsisdnEndpointIdentifier {
                    msisdn
                  }
                }
              }
              createdAt
              paymentOptions {
                methods {
                  clientConfiguration
                  description
                  id
                  methodType
                  name
                  sdk
                }
                savedMethods {
                  description
                  id
                  lastUsedAt
                  methodType
                  isAvailable
                  brand {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
        `,
      variables: {
        input: {
          orderId: orderId
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export {
  createAndValidateOrder,
  getPayments,
  submitOrder,
  getOrderState,
  submit3DSecureData,
  getOrders,
  getOperatorByMsisdn,
  getOrderHistory,
  getBundleProducts,
  getMtuProducts,
  getNautaProducts,
  getOperatorByEmail,
  createAndValidateNautaOrder,
  getProductInfo,
  getAvailableCountriesForMTU,
  submitPrebookingOrder,
  cancelOrder,
  createAndValidatePrebooking,
  createAndValidateSubscription,
  submitRecurringSubscription,
  fetchTopupSubscriptionsByFilter,
  fetchTopupSubscriptions,
  cancelSubscription,
  reActivateSubscription,
  getOperatorByCountry,
  getAllMtuProducts,
  removeSubscription,
  updateSubscription,
  fetchCubaBannerInfo,
  useCreditBalance,
  removeCreditBalance
}



// WEBPACK FOOTER //
// ./src/api/marketplace/index.js